import type { ReactNode } from "react";

type ContainerProps = {
  children: ReactNode;
  className?: string;
};

/** Brand grid: 1280px max width, 20px mobile margin, 64px desktop margin. */
export function Container({ children, className = "" }: ContainerProps) {
  return <div className={`mx-auto w-full max-w-[1280px] px-5 lg:px-16 ${className}`}>{children}</div>;
}
